import { Outlet } from "react-router-dom";
import LeadsKanbanV2 from "./LeadsKanbanV2";

export const adminLeadsRoutes = [
  {
    path: "leads",
    element: Outlet,
    children: [
      {
        path: "",
        element: LeadsKanbanV2,
      },
    ],
  },
];
